"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _prefix = _interopRequireDefault(require("../prefix"));

var DropdownOption = function DropdownOption(_ref) {
  var active = _ref.active,
      callback = _ref.callback,
      children = _ref.children,
      className = _ref.className,
      eventKey = _ref.eventKey,
      disabled = _ref.disabled,
      _ref$divider = _ref.divider,
      divider = _ref$divider === void 0 ? false : _ref$divider,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? false : _ref$header,
      htmlId = _ref.htmlId,
      innerRef = _ref.innerRef,
      _ref$itemProps = _ref.itemProps,
      itemProps = _ref$itemProps === void 0 ? {} : _ref$itemProps,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      onSelect = _ref.onSelect,
      value = _ref.value;

  var handleSelect = function handleSelect(event) {
    return !disabled && onSelect(value, itemProps, event, callback);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
    "aria-label": value,
    "aria-selected": active,
    className: (0, _classnames["default"])(["".concat(_prefix["default"], "dropdown-item"), active && "active", disabled && "disabled", header && "".concat(_prefix["default"], "dropdown-header"), className && className]),
    "data-index": eventKey,
    id: "".concat(htmlId, "-selectInput-").concat(eventKey),
    onClick: handleSelect,
    onKeyPress: handleSelect,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    ref: innerRef,
    role: header ? "heading" : "option",
    tabIndex: 0
  }, children ? children : label), divider && /*#__PURE__*/_react["default"].createElement("li", {
    id: "".concat(htmlId, "-divider"),
    className: (0, _classnames["default"])(["".concat(_prefix["default"], "dropdown-item--divider"), "divider"]),
    role: "separator"
  }));
};

var _default = DropdownOption;
exports["default"] = _default;